import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);
/*
Ver documentación en: https://vuex.vuejs.org/api/#mutations
*/

const RolesVuexModule = {
  namespaced: true,
  state: () => ({
    $_moduleApiPath: "Role/v1.0/",
    $_moduleClaims: "ApplicationClaims/v1.0/",
    $_roles: [],
    $_applicationClaims: [],
    $_currentRole: {},
    $_errorState: {},
    $_actionState: {
      message: "",
      status: 200,
      data: {}
    }
  }),
  getters: {
    allRoles: (state) => state.$_roles,
    allApplicationClaims: (state) => state.$_applicationClaims,
    currentRole: (state) => state.$_currentRole,
    actionState: (state) => state.$_actionState,
    errorState: (state) => state.$_errorState
  },
  actions: {
    initRole({ commit }) {
      var role = {
        id: 0,
        name: "",
        active: false,
        roleClaims: [],
        application: {
          id: 0
        }
      };

      commit("SET_ROLE", role);
    },
    clearRoles({ commit }) {
      commit("SET_ROLES", []);
    },
    setRole({ commit }, role) {
      commit("SET_ROLE", role);
    },
    async getRoles({ commit, dispatch, state, rootGetters }) {
      var authUrl = rootGetters.authUrl;
      var actionLink =
        authUrl +
        state.$_moduleApiPath +
        "GetRolesByApplicationIdAsync" +
        ":" +
        rootGetters.applicationId;
      var axiosConfig = rootGetters.authaxiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_ROLES", response.data.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async getApplicationClaims({ commit, dispatch, state, rootGetters }) {
      var authUrl = rootGetters.authUrl;
      var actionLink =
        authUrl +
        state.$_moduleClaims +
        "GetApplicationClaimsAsync" +
        ":" +
        rootGetters.applicationId;
      var axiosConfig = rootGetters.authaxiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_APPLICATION_CLAIMS", response.data.data);
      } catch (error) {
        commit("SET_ERROR", error.response);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async getRole({ commit, dispatch, state, rootGetters }, id) {
      var authUrl = rootGetters.authUrl;
      var actionLink =
        authUrl + state.$_moduleApiPath + "GetRolesByIdAsync" + ":" + id;
      var axiosConfig = rootGetters.authaxiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_ROLE", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async createRole({ commit, dispatch, state, rootGetters }, role) {
      var authUrl = rootGetters.authUrl;
      var actionLink = authUrl + state.$_moduleApiPath + "CreateRolesAsync";
      var axiosConfig = rootGetters.authaxiosConfig;
      try {
        role.application.id = rootGetters.applicationId;
        const response = await axios.post(actionLink, role, axiosConfig);
        role.id = response.data.id;
        commit("SET_ROLE", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async updateRole({ commit, dispatch, state, rootGetters }, data) {
      var authUrl = rootGetters.authUrl;
      var actionLink = authUrl + state.$_moduleApiPath + "UpdateRolesAsync";
      var axiosConfig = rootGetters.authaxiosConfig;
      try {
        data.role.application = { id: rootGetters.applicationId };

        const response = await axios.put(actionLink, data.role, axiosConfig);
        data.role.id = response.data.id;
        commit("SET_ROLE", data.role);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    }
  },
  mutations: {
    SET_ROLES(state, value) {
      state.$_roles = value;
    },
    SET_APPLICATION_CLAIMS(state, value) {
      state.$_applicationClaims = value;
    },
    SET_ROLE(state, value) {
      state.$_currentRole = value;
    },
    SET_ERROR(state, value) {
      state.$_errorState = value;
    }
  }
};

export default RolesVuexModule;
